import type { Column } from "./utils-v2";

export const ALL_SPORTSBOOK_COLUMNS: Column[] = [
  {
    key: "fanduel_odds",
    label: "FanDuel",
    icon: true,
    sportsbook: "FD",
    className: "font-bold fanduel-column",
    platform: "fanduel",
  },
  {
    key: "draftkings_odds",
    label: "DraftKings",
    icon: true,
    sportsbook: "DK",
    className: "font-bold draftkings-column",
    platform: "draftkings",
  },
  {
    key: "pinnacle_odds",
    label: "Pinnacle",
    icon: true,
    sportsbook: "PN",
    className: "font-bold pinnacle-column",
    platform: "pinnacle",
  },
  {
    key: "circa_odds",
    label: "Circa",
    icon: true,
    sportsbook: "CR",
    className: "font-bold circa-column",
    platform: "circa",
  },
  {
    key: "caesars_odds",
    label: "Caesars",
    icon: true,
    sportsbook: "CS",
    className: "font-bold caesars-column",
    platform: "caesars",
  },
  {
    key: "novig_odds",
    label: "Novig",
    icon: true,
    sportsbook: "NV",
    className: "font-bold novig-column",
    platform: "novig",
  },
  {
    key: "prophetx_odds",
    label: "ProphetX",
    icon: true,
    sportsbook: "PX",
    className: "font-bold prophetx-column",
    platform: "prophetx",
  },
  {
    key: "hardrock_odds",
    label: "Hard Rock",
    icon: true,
    sportsbook: "HR",
    className: "font-bold hardrock-column",
    platform: "hardrock",
  },
  {
    key: "prizepicks_odds",
    label: "PrizePicks",
    icon: true,
    sportsbook: "PP",
    className: "font-bold prizepicks-column",
    platform: "prizepicks",
  },
  {
    key: "underdog_direct_odds",
    label: "Underdog",
    icon: true,
    sportsbook: "UD",
    className: "font-bold underdog-column",
    platform: "underdog",
  },
  {
    key: "sleeper_direct_odds",
    label: "Sleeper",
    icon: true,
    sportsbook: "SL",
    className: "font-bold sleeper-column",
    platform: "sleeper",
  },
  {
    key: "fliff_odds",
    label: "Fliff",
    icon: true,
    sportsbook: "FL",
    className: "font-bold fliff-column",
    platform: "fliff",
  },
  {
    key: "betmgm_odds",
    label: "BetMGM",
    icon: true,
    sportsbook: "MG",
    className: "font-bold betmgm-column",
    platform: "betmgm",
  },
  {
    key: "fanatics_odds",
    label: "Fanatics",
    icon: true,
    sportsbook: "FA",
    className: "font-bold fanatics-column",
    platform: "fanatics",
  },
  {
    key: "betr_odds",
    label: "Betr",
    icon: true,
    sportsbook: "BR",
    className: "font-bold betr-column",
    platform: "betr",
  },
  {
    key: "dabble_odds",
    label: "Dabble",
    icon: true,
    sportsbook: "DB",
    className: "font-bold dabble-column",
    platform: "dabble",
  },
  {
    key: "kalshi_odds",
    label: "Kalshi",
    icon: true,
    sportsbook: "kalshi",
    className: "font-bold kalshi-column",
    platform: "kalshi",
  },
  {
    key: "polymarket_odds",
    label: "Polymarket",
    icon: true,
    sportsbook: "PM",
    className: "font-bold polymarket-column",
    platform: "polymarket",
  },
  {
    key: "rebet_odds",
    label: "Rebet",
    icon: true,
    sportsbook: "RB",
    className: "font-bold rebet-column",
    platform: "rebet",
  },
  {
    key: "draftkingspredictions_odds",
    label: "DK Predictions",
    icon: true,
    sportsbook: "DKP",
    className: "font-bold draftkingspredictions-column",
    platform: "draftkingspredictions",
  },
  {
    key: "kambi_odds",
    label: "Kambi",
    icon: true,
    sportsbook: "KM",
    className: "font-bold kambi-column",
    platform: "kambi",
  },
  {
    key: "betonline_odds",
    label: "BetOnline",
    icon: true,
    sportsbook: "BO",
    className: "font-bold betonline-column",
    platform: "betonline",
  },
  {
    key: "propbuilder_odds",
    label: "PropBuilder",
    icon: true,
    sportsbook: "PRB",
    className: "font-bold propbuilder-column",
    platform: "propbuilder",
  },
  {
    key: "bovada_odds",
    label: "Bovada",
    icon: true,
    sportsbook: "BV",
    className: "font-bold bovada-column",
    platform: "bovada",
  },
  {
    key: "betrsportsbook_odds",
    label: "Betr Sportsbook",
    icon: true,
    sportsbook: "BRS",
    className: "font-bold betrsportsbook-column",
    platform: "betrsportsbook",
  },
  {
    key: "shuffle_odds",
    label: "Shuffle",
    icon: true,
    sportsbook: "SH",
    className: "font-bold shuffle-column",
    platform: "shuffle",
  },
  {
    key: "sportzino_odds",
    label: "Sportzino",
    icon: true,
    sportsbook: "SZ",
    className: "font-bold sportzino-column",
    platform: "sportzino",
  },
  {
    key: "sportsbettingag_odds",
    label: "SportsBetting AG",
    icon: true,
    sportsbook: "SBAG",
    className: "font-bold sportsbettingag-column",
    platform: "sportsbettingag",
  },
  {
    key: "dkpick6_odds",
    label: "DK Pick6",
    icon: true,
    sportsbook: "DKP6",
    className: "font-bold dkpick6-column",
    platform: "dkpick6",
  },
  {
    key: "parlayplay_odds",
    label: "ParlayPlay",
    icon: true,
    sportsbook: "ParlayPlay",
    className: "font-bold parlayplay-column",
    platform: "parlayplay",
  },
  {
    key: "tailgate_odds",
    label: "Tailgate",
    icon: true,
    sportsbook: "TG",
    className: "font-bold tailgate-column",
    platform: "tailgate",
  },
  {
    key: "sleeperpredict_odds",
    label: "Sleeper Markets",
    icon: true,
    sportsbook: "SLP",
    className: "font-bold sleeperpredict-column",
    platform: "sleeperpredict",
  },
  {
    key: "courtside_odds",
    label: "Courtside",
    icon: true,
    sportsbook: "CT",
    className: "font-bold courtside-column",
    platform: "courtside",
  },
  {
    key: "boomsports_odds",
    label: "Boom",
    icon: true,
    sportsbook: "BM",
    className: "font-bold boomsports-column",
    platform: "boomsports",
  },
  {
    key: "chalkboardpicks_odds",
    label: "Chalkboard Picks",
    icon: true,
    sportsbook: "CB",
    className: "font-bold chalkboardpicks-column",
    platform: "chalkboardpicks",
  },
  {
    key: "chalkboardssp_odds",
    label: "Chalkboard",
    icon: true,
    sportsbook: "CBS",
    className: "font-bold chalkboardssp-column",
    platform: "chalkboardssp",
  },
  {
    key: "smacktok_odds",
    label: "SmackTok",
    icon: true,
    sportsbook: "SMK",
    className: "font-bold smacktok-column",
    platform: "smacktok",
  },
  {
    key: "fourcx_odds",
    label: "4Cx",
    icon: true,
    sportsbook: "4CX",
    className: "font-bold fourcx-column",
    platform: "fourcx",
  },
  {
    key: "fourcasters_odds",
    label: "4casters",
    icon: true,
    sportsbook: "4C",
    className: "font-bold fourcasters-column",
    platform: "fourcasters",
  },
  {
    key: "sxbet_odds",
    label: "SX Bet",
    icon: true,
    sportsbook: "SX",
    className: "font-bold sxbet-column",
    platform: "sxbet",
  },
  {
    key: "bet105_odds",
    label: "Bet105",
    icon: true,
    sportsbook: "B105",
    className: "font-bold bet105-column",
    platform: "bet105",
  },
  {
    key: "onyxodds_odds",
    label: "Onyx Odds",
    icon: true,
    sportsbook: "ONYX",
    className: "font-bold onyxodds-column",
    platform: "onyxodds",
  },
  {
    key: "thunderpick_odds",
    label: "Thunderpick",
    icon: true,
    sportsbook: "TP",
    className: "font-bold thunderpick-column",
    platform: "thunderpick",
  },
  {
    key: "cryptocom_odds",
    label: "Crypto.com",
    icon: true,
    sportsbook: "CDC",
    className: "font-bold cryptocom-column",
    platform: "cryptocom",
  },
];

export const PLATFORM_TO_LOGO_CODE: Record<string, string> = ALL_SPORTSBOOK_COLUMNS.reduce(
  (acc, col) => {
    if (col.platform && col.sportsbook) {
      acc[col.platform] = col.sportsbook;
    }
    return acc;
  },
  {} as Record<string, string>
);
